module.exports = __webpack_public_path__ + "static/media/antiClippyL.e7fe0987.png";